import React from 'react';
import { Typography } from '@mui/material';
import PageMetadata from '../components/PageMetadata';
import TaskPrioritizer from '../components/TaskPrioritizer';
import { toolTextSx } from '../components/ToolCard';

const DESCRIPTION = 'Prioritize your to-do list by comparing two tasks at a time. Get a ranked checklist to use here or copy to your notes. Free, browser-only, no account needed.';
const URL = 'https://dopatize.com/tools/prioritize';
const SCHEMA = { '@context': 'https://schema.org', '@type': 'WebApplication', name: 'Dopatize Task Prioritizer',
  description: DESCRIPTION, url: URL, applicationCategory: 'LifestyleApplication', operatingSystem: 'Any', isAccessibleForFree: true };

export default function TaskPrioritizerPage() {
  return (
    <>
      <PageMetadata title="Free Task Prioritizer & Checklist | Dopatize" description={DESCRIPTION} url={URL} structuredData={SCHEMA} />
      <Typography component="h1" sx={{ fontSize: { xs: '1.2rem', sm: '1.7rem' }, lineHeight: 1.9, textAlign: 'center', m: 0 }}>Prioritize your to-do list</Typography>
      <Typography sx={{ ...toolTextSx, textAlign: 'center', mt: 2, mb: 4 }}>Choose what matters more, two tasks at a time.</Typography>
      <TaskPrioritizer />
      <Typography sx={{ ...toolTextSx, color: 'text.primary', mt: 4 }}>Saved on this device.</Typography>
    </>
  );
}
